<template lang="pug">
	.stepper-component(v-if="steps && steps.length", :style="{ height: `${stepperHeight}px` }")
		.stepper
			template(v-for="(mainStepObj, mainStepIndex) in steps")
				.stepper-item.dx-item.dx-treeview-item(:class="{current: mainStep === mainStepIndex, complete: mainStepIndex < mainStep}", @click="mainStep = mainStepIndex; subStep = 0")
					.dx-item-content.dx-treeview-item-content
						.flex-row.align-center.space
							i(:class="[mainStepObj.icon]")
							span.step-name {{mainStepObj.name}}
							.rounded-number.flex-row.align-center.center(v-if="mainStep === mainStepIndex && !hideStepNumbers")
								span {{mainStepIndex + 1}}
		.sub-steps(v-if="subStepsVisible && currentSubStep")
			DxScrollView(direction="horizontal", height="65px").scroll-view
				.header-data
					.content-block.header
						DxDropDownButton(:split-button="true"
							:use-select-mode="false",
							:items="dropDownSteps",
							display-expr="name",
							key-expr="name",
							stylingMode="text",
							:text="currentSubStep.name",
							@item-click="onSubStepClick"
						)
					.actions-buttons-group
						DxButton(v-if="canPrev", :text="$tCaption('Back')", icon="chevrondoubleleft", @click="prevStep", type="normal")
						template(v-for="action in actions.items")
							DxButton(v-if="actions.getVisibility(action, mainStep, subStep)", :disabled="actions.getDisabled(action, mainStep, subStep)", :text="action.name()", @click="action.handler", type="default", :icon="action.icon")
						DxButton(v-if="hasNext", :disabled="!canNext", :text="$tCaption('Next')", icon="chevrondoubleright", @click="nextStep", type="default")
						slot(name="actions")
					slot
</template>

<script>
	import _ from 'lodash';
	import BuilderStep from './BuilderStep.vue';
	import DxButton from 'devextreme-vue/button';
	import DxDropDownButton from 'devextreme-vue/drop-down-button';
	import VueTypes from 'vue-types';
	import DxScrollView from 'devextreme-vue/scroll-view';

	export default {
		translationCategory: 'proposal.Stepper',
		name: 'proposal-builder',
		components: {
			BuilderStep,
			DxButton,
			DxDropDownButton,
			DxScrollView
		},
		props: {
			steps: VueTypes.array.def([]),
			actions: VueTypes.object.def({}),
			initialSteps: VueTypes.array.def([]),
			subStepsVisible: VueTypes.bool.def(true),
			hideStepNumbers: VueTypes.bool.def(false)
		},
		data() {
			return {
				mainStep: this.initialSteps[0] || 0,
				subStep: this.initialSteps[1] || 0
			};
		},
		computed: {
			currentMainStep() {
				return this.steps[this.mainStep];
			},
			currentSubStep() {
				return this.currentMainStep && this.currentMainStep.steps[this.subStep];
			},
			hasNext() {
				return this.currentMainStep.steps.length > this.subStep + 1 || this.steps.length > this.mainStep + 1;
			},
			canNext() {
				if (this.currentSubStep.canNext) {
					return this.currentSubStep.canNext();
				}
				return this.hasNext;
			},
			canPrev() {
				return this.subStep > 0 || this.mainStep > 0;
			},
			dropDownSteps() {
				return this.currentMainStep.steps.slice(0, this.subStep + 1);
			},
			stepperHeight() {
				return 48 + (this.subStepsVisible ? 65 : 0);
			}
		},
		watch: {
			mainStep() {
				this.emitStepChanged();
			},
			subStep() {
				this.emitStepChanged();
			}
		},
		mounted() {
			this.emitStepChanged();
		},
		methods: {
			emitStepChanged() {
				this.$emit('step-changed', this.currentSubStep, [this.mainStep, this.subStep]);
			},
			onSubStepClick(e) {
				this.subStep = _.findIndex(this.currentMainStep.steps, {name: e.itemData.name});
			},
			nextStep() {
				if (this.currentMainStep.steps.length > this.subStep + 1)
					this.subStep++;
				else if (this.steps.length > this.mainStep + 1) {
					this.mainStep++;
					this.subStep = 0;
				}
			},
			prevStep() {
				if (this.subStep > 0)
					this.subStep--;
				else if (this.mainStep > 0) {
					this.mainStep--;
					this.subStep = this.currentMainStep.steps.length-1;
				}
			},
			isMainStepActive(data) {
				return this.mainSteps.indexOf(data) === this.currentMainStep;
			}
		}
	};
</script>
<style lang='scss'>
	.stepper-component {
		@import "main/themes/generated/variables.base.scss";
		.content-block.header {
			padding-top: 5px;
			padding-left: 10px;
			font-size: 24px;

			.dx-button-text {
				font-size: 30px;
				font-weight: 100;
				letter-spacing: 0;
				text-transform: initial;
			}
		}

		.sub-steps {
			height: 65px;
			position: absolute;
			top: 48px;
			width: 100%;

			h3 {
				font-size: 30px;
				font-weight: 100;
			}

			.content-block.header {
				padding-left: 0px;
			}
		}

		.stepper {
			display: flex;
			padding: 0;
			list-style: none;
			position: absolute;
			margin: 0px 0px 0px 14px;
			height: 48px;
			top: 0px;
			left: 0px;
			right: 0px;

			&::before {
				position: absolute;
				top: 0;
				left: 0;
				height: 100%;
				content: "";
				width: calc(100% - 20px);
				background: #e7e7e7;
			}
		}

		.stepper-item {
			flex: 100%;
			padding: 12px;
			background: #fff;
			margin: 0 0 0 -14px;
			-webkit-clip-path: polygon(20px 50%, 0% 0%, calc(100% - 20px) 0%, 100% 50%, calc(100% - 20px) 100%, 0% 100%);
			font-size: 16px;
			font-weight: 100;
			text-align: left;
			position: relative;
			color: $base-accent;
			transition: 0.3s;
			overflow: hidden;
			user-select: none;

			&.current {
				background: $base-accent;
				color: #fff;
				padding-right: 55px;
				overflow: inherit;
			}

			&.complete {
				background: $base-accent;
				color: #fff;
				padding-right: 10px;
			}

			&:first-child {
				-webkit-clip-path: polygon(0% 0%, calc(100% - 20px) 0%, 100% 50%, calc(100% - 20px) 100%, 0% 100%);
			}

			&:not(:first-child) {
				padding-left: 30px;
			}

			&:last-child {
				-webkit-clip-path: polygon(20px 50%, 0% 0%, 100% 0%, 100% 100%, 0% 100%);
			}

			.rounded-number {
				text-align: center;
				background: #693366;
				min-width: 30px;
				height: 30px;
				vertical-align: middle;
				line-height: 1.4;
				border-radius: 30px;
				color: #fff;
				position: absolute;
				right: 20px;
				top: 10px;
				font-size: 12px;
			}

			&.complete, &.current {
				.rounded-number {
					background: #fff;
					color: #693366;
				}
			}

			.dx-item-content {
				> .fas, .svg-inline--fa {
					margin: 0px 6px 0px 0px;
				}
			}
			> .dx-item-content.dx-treeview-item-content {
				display: flex;
				flex-wrap: nowrap;
				white-space: nowrap;

				> .step-name {
					text-overflow: ellipsis;
					overflow: hidden;
				}
			}
		}

		.header-data {
			display: flex;
			align-items: center;

			> .header {
				margin: 10px 20px 10px 40px;
			}
		}

		.actions-buttons-group {
			display: flex;
			flex-direction: row;
			z-index: 1000;
			align-items: center;

			> * {
				margin-right: 4px;
			}
		}
	}
</style>
